import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { MiddlewareAPI } from '../../../config/api';
import { IBadRequestResponse } from '../../../interfaces/IBadRequestResponse';
import { IParceiro } from '../../../interfaces/response/Parceiros/IParceiro';

// =========================
// GET ALL
// =========================

export const getParceirosEntrega = createAsyncThunk(
  'parceiros/getParceirosEntrega',
  async (args, { rejectWithValue }): Promise<IParceiro[] | any> => {
    try {
      const response = await MiddlewareAPI.get(`/v1/Parceiros/entrega`);
      return response.data;
    } catch (err: any) {
      const error = err as AxiosError<IBadRequestResponse>;
      return rejectWithValue(error);
    }
  }
);

export const getParceirosColeta = createAsyncThunk(
  'parceiros/getParceirosColeta',
  async (args, { rejectWithValue }): Promise<IParceiro[] | any> => {
    try {
      const response = await MiddlewareAPI.get(`/v1/Parceiros/coleta`);
      return response.data;
    } catch (err: any) {
      const error = err as AxiosError<IBadRequestResponse>;
      return rejectWithValue(error);
    }
  }
);

// =========================
// GET BY ID
// =========================

export const getParceirosEntregaById = createAsyncThunk(
  'parceiros/getParceirosEntregaById',
  async (
    args: { id: string },
    { rejectWithValue }
  ): Promise<IParceiro | any> => {
    try {
      const response = await MiddlewareAPI.get(
        `/v1/Parceiros/entrega/${args.id}`
      );
      return response.data;
    } catch (err: any) {
      const error = err as AxiosError<IBadRequestResponse>;
      return rejectWithValue(error);
    }
  }
);

export const getParceirosColetaById = createAsyncThunk(
  'parceiros/getParceirosColetaById',
  async (
    args: { id: string },
    { rejectWithValue }
  ): Promise<IParceiro | any> => {
    try {
      const response = await MiddlewareAPI.get(
        `/v1/Parceiros/coleta/${args.id}`
      );
      return response.data;
    } catch (err: any) {
      const error = err as AxiosError<IBadRequestResponse>;
      return rejectWithValue(error);
    }
  }
);

// =========================
// ADD
// =========================

export const addParceiroEntrega = createAsyncThunk(
  'parceiros/addParceiroEntrega',
  async (
    args: { body: IParceiro },
    { rejectWithValue }
  ): Promise<boolean | any> => {
    try {
      const response = await MiddlewareAPI.post(
        `/v1/Parceiros/entrega`,
        args.body
      );
      return response.data;
    } catch (err: any) {
      const error = err as AxiosError<IBadRequestResponse>;
      return rejectWithValue(error);
    }
  }
);

export const addParceiroColeta = createAsyncThunk(
  'parceiros/addParceiroColeta',
  async (
    args: { body: IParceiro },
    { rejectWithValue }
  ): Promise<boolean | any> => {
    try {
      const response = await MiddlewareAPI.post(
        `/v1/Parceiros/coleta`,
        args.body
      );
      return response.data;
    } catch (err: any) {
      const error = err as AxiosError<IBadRequestResponse>;
      return rejectWithValue(error);
    }
  }
);

// =========================
// EDIT
// =========================

export const editParceiroEntrega = createAsyncThunk(
  'parceiros/editParceiroEntrega',
  async (
    args: { body: IParceiro },
    { rejectWithValue }
  ): Promise<boolean | any> => {
    try {
      const response = await MiddlewareAPI.put(
        `/v1/Parceiros/entrega`,
        args.body
      );
      return response.data;
    } catch (err: any) {
      const error = err as AxiosError<IBadRequestResponse>;
      return rejectWithValue(error);
    }
  }
);

export const editParceiroColeta = createAsyncThunk(
  'parceiros/editParceiroColeta',
  async (
    args: { body: IParceiro },
    { rejectWithValue }
  ): Promise<boolean | any> => {
    try {
      const response = await MiddlewareAPI.put(
        `/v1/Parceiros/coleta`,
        args.body
      );
      return response.data;
    } catch (err: any) {
      const error = err as AxiosError<IBadRequestResponse>;
      return rejectWithValue(error);
    }
  }
);

// =========================
// DELETE
// =========================

export const deleteParceiroEntrega = createAsyncThunk(
  'parceiros/deleteParceiroEntrega',
  async (args: { id: string }, { rejectWithValue }): Promise<boolean | any> => {
    try {
      const response = await MiddlewareAPI.delete(
        `/v1/Parceiros/entrega/${args.id}`
      );
      return response.data;
    } catch (err: any) {
      const error = err as AxiosError<IBadRequestResponse>;
      return rejectWithValue(error);
    }
  }
);

export const deleteParceiroColeta = createAsyncThunk(
  'parceiros/deleteParceiroColeta',
  async (args: { id: string }, { rejectWithValue }): Promise<boolean | any> => {
    try {
      const response = await MiddlewareAPI.delete(
        `/v1/Parceiros/coleta/${args.id}`
      );
      return response.data;
    } catch (err: any) {
      const error = err as AxiosError<IBadRequestResponse>;
      return rejectWithValue(error);
    }
  }
);
